// После деплоя открытая вкладка ещё держит старый бандл и просит чанки со
// старыми хешами, которых на сервере уже нет. Лечится одной перезагрузкой —
// делаем её сами, но не чаще раза в 30 секунд, чтобы не уйти в цикл, если
// чанк не грузится по другой причине (нет сети).
const KEY = "turaq.staleReloadAt";
const WINDOW_MS = 30_000;

export const CHUNK_ERROR_RE =
  /dynamically imported module|Importing a module script failed|Loading chunk|Unable to preload CSS|error loading dynamically imported module|is not a valid JavaScript MIME type/i;

export function isChunkError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERROR_RE.test(error.message);
}

/** true — перезагрузка запущена; false — уже пробовали недавно, показываем ошибку. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < WINDOW_MS) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

/** Vite сообщает о неудачной подгрузке чанка событием vite:preloadError. */
export function installStaleBuildReload(): void {
  window.addEventListener("vite:preloadError", (event) => {
    if (reloadForNewBuild()) event.preventDefault();
  });
}
